module.exports = __webpack_public_path__ + "assets/img/fa044d4801354d767fc9cf89455bc23a.svg";